module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/institutions/icon_phone--light-blue-4e4ac5e39a63cdb15fdbe84a5c14df11.svg";